import React from "react";
import { useNavigate } from "react-router";
import { Plus } from "lucide-react";

import { Button } from "../../../components/ui/button";
import { usePricing } from "../../../contexts/PricingContext";
import { formatCurrency } from "../../../lib/pricing";
import { PRICING_PATH } from "../../forms/ZoneForm";
import { Item } from "../settings/Item";
import ListRow from "./ListRow";
import { useDeleteItem } from "./useDeleteItem";

export default function ExtrasTab() {
  const { extras } = usePricing();
  const navigate = useNavigate();
  const { requestDelete, dialog } = useDeleteItem("extras", "Adicional");

  return (
    <Item className="space-y-4">
      {extras.length === 0 ? (
        <p className="text-sm text-white/60">
          Nenhum adicional cadastrado. Adicionais são opcionais (ex.: cadeirinha, parada extra).
        </p>
      ) : (
        <div className="space-y-2">
          {extras.map((extra) => (
            <ListRow
              key={extra.id}
              title={extra.name}
              subtitle={`${formatCurrency(extra.price)} · ${extra.type === "perPax" ? "por passageiro" : "por viagem"}`}
              active={extra.active}
              onEdit={() => navigate(`${PRICING_PATH}/extras/edit/${extra.id}`)}
              onDelete={() => requestDelete(extra.id, extra.name)}
            />
          ))}
        </div>
      )}
      <Button variant="outline" className="w-full" onClick={() => navigate(`${PRICING_PATH}/extras/add`)}>
        <Plus className="h-4 w-4" /> Adicionar adicional
      </Button>
      {dialog}
    </Item>
  );
}
